const PersistentStorage = {
  set(key, value) {
    try {
      const serialized = JSON.stringify(value)
      localStorage.setItem(key, serialized)
    } catch (e) {
      console.error(`Storage set error for key "${key}":`, e)
    }
  },
  get(key, defaultValue = null) {
    try {
      const item = localStorage.getItem(key)
      return item ? JSON.parse(item) : defaultValue
    } catch (e) {
      console.error(`Storage get error for key "${key}":`, e)
      return defaultValue
    }
  },
  remove(key) {
    try {
      localStorage.removeItem(key)
    } catch (e) {
      console.error(`Storage remove error for key "${key}":`, e)
    }
  },
  clear() {
    try {
      localStorage.clear()
    } catch (e) {
      console.error(`Storage clear error:`, e)
    }
  }
}

export default PersistentStorage



// WEBPACK FOOTER //
// ./src/libs/persistent.storage/index.js